import { useSyncExternalStore } from 'react';

const subscribe = () => () => {
  /* empty */
};

/** `false` en el servidor y durante la hidratación; `true` una vez montado en el cliente. */
export function useIsMounted() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
